import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { BorderStyleEnum, BorderTypeEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { RegistrationButtonInterface } from 'src/shared/types/entities/registration-button-interface'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'

export const createRegistrationButton = (
  parentId: string,
  text: string,
  subText: string,
  masterBlockId?: MasterBlockId,
) => {
  const button: RegistrationButtonInterface = {
    ...generateBaseEntity(
      EntityTypeEnum.RegistrationButton,
      parentId,
      masterBlockId,
    ),
    type: EntityTypeEnum.RegistrationButton,
    buttonType: WebsiteSettingsTypographyTypeEnum.PrimaryButton,
    iconClassNameBefore: '',
    iconClassNameAfter: '',
    textFontSize: 14,
    subTextFontSize: 12,
    textColor: 'rgb(24, 25, 28)',
    subTextColor: 'rgba(255,255,255,0.8)',
    backgroundColor: 'rgb(255, 255, 255)',
    alignSelf: 'center',
    text,
    subText,
    width: 'auto',
    boxShadow: 'none',
    mobileSubTextFontSize: 12,
    mobileTextFontSize: 14,
    mobileWidth: '100%',
    mobileAlignSelf: 'center',
    mobileBoxShadow: 'none',
    border: {
      color: 'rgb(200, 202, 208)',
      radius: {
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
        borderBottomLeftRadius: 10,
      },
      style: BorderStyleEnum.solid,
      type: BorderTypeEnum.fullBorder,
      width: 1,
    },
    mobileBorder: {
      color: 'rgb(200, 202, 208)',
      radius: {
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
      },
      style: BorderStyleEnum.solid,
      type: BorderTypeEnum.fullBorder,
      width: 1,
    },
    padding: {
      paddingBottom: 6,
      paddingTop: 6,
      paddingLeft: 12,
      paddingRight: 12,
    },
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobilePadding: {
      paddingTop: 5,
      paddingRight: 5,
      paddingBottom: 5,
      paddingLeft: 5,
    },
    hover: {
      backgroundColor: 'rgb(255, 255, 255)',
    },
  }

  if (masterBlockId) {
    button.masterBlockId = masterBlockId
  }

  return button
}
